import React from "react";

import { Link } from "react-router-dom";
import { translate } from "react-i18next";

import User from "../../util/User"; 
import MenueItem from "./menue-item"; 
import { BaseMenu } from './base-menu';

class UserMenue extends BaseMenu {
  constructor(props) {
    super(props, 'USER_MENU');
  }

  render() {
    const { t } = this.props;
    const show = this.status.show;

    let menue = null;
    if (User.isAuthenticated()) {
      menue = (
        <ul className="nav navbar-nav" onClick={this.toggleShow} onMouseOver={this.showMenu} >
          <li className="dropdown open">
            <a className="dropdown-toggle">
              {User.firstname} {User.lastname}
            </a>
            {show && (
              <ul className="dropdown-menu">
                <MenueItem title="userData" to="/user/data" />
                <MenueItem title="logout" to="/user/login" />
                <li class="divider"></li>
                <MenueItem title="medicationList" to="/medicationlist" />
                <MenueItem title="testpage" to="/testpage" />
                <MenueItem title="expandabletable" to="/expandabletable" />
                <MenueItem title="expandabletable2" to="/expandabletable2" />
              </ul>
            )}
          </li>
        </ul>
      );
    } else {
      menue = (
        <ul className="nav navbar-nav" onClick={this.toggleShow} onMouseOver={this.showMenu} >
          <li className="dropdown open">
            <a className="dropdown-toggle">
              {t("login")}/{t("register")}
            </a>
            {show && (
              <ul className="dropdown-menu">
                <li>
                  <Link to="/user/login">{t("login")}</Link>
                </li>
                <li>
                  <Link to="/user/register">{t("register")}</Link>
                </li>
              </ul>
            )}
          </li>
        </ul>
      );
    }

    return menue;
  }
}

export default translate()(UserMenue);
